import React, {Fragment, useEffect} from "react";
import {observer} from "mobx-react-lite";
import {Grid, GridColumn as Column, GridPageChangeEvent, GridSortChangeEvent,} from "@progress/kendo-react-grid";

import {useStore} from '../../../app/stores/store';
import {Button} from "semantic-ui-react";
import {orderBy, SortDescriptor, State} from "@progress/kendo-data-query";
import LoadingComponent from "../../../app/layout/LoadingComponent";

export default observer(function GroupLiversList() {
    const {ideaStore, adminStore} = useStore();
    let {
        loadingInitial
    } = ideaStore;

    let {
        loadGroupLivers, groupLivers, groupLiversRegistry, loadGroupLiver,
        setGroupLiverLoaded
    } = adminStore;


    const initialDataState: State = {skip: 0, take: 4};

    const [page, setPage] = React.useState<any>(initialDataState);

    const pageChange = (event: GridPageChangeEvent) => {
        setPage(event.page);
    };
    const initialSort: Array<SortDescriptor> = [
        {field: "groupLiverId", dir: "asc"},
    ];
    const [sort, setSort] = React.useState(initialSort);


    useEffect(() => {
        if (groupLiversRegistry.size < 1) loadGroupLivers();
    }, [loadGroupLivers])

    const setGroupLiver = (groupLiverId: number) => {
        loadGroupLiver(groupLiverId)
        setGroupLiverLoaded(true)
    }

    const groupLiverIdCell = (props: any) => {
        return (
            <td

            ><Button basic as={Button}
                     onClick={() => setGroupLiver(props.dataItem.groupLiverId)}
                     color='blue'
                     size='mini'>
                {props.dataItem.groupLiverId}
            </Button>


            </td>
        )
    }

    if (loadingInitial) return <LoadingComponent content='Loading group livers...'/>
    return (

        <Fragment>

            <Grid className="main-grid"  style={{height: "400px"}}
                  data={orderBy(groupLivers, sort).slice(page.skip, page.take + page.skip)}
                  sortable={true}
                  sort={sort}
                  onSortChange={(e: GridSortChangeEvent) => {
                      setSort(e.sort);
                  }}
                  skip={page.skip}
                  take={page.take}
                  total={groupLivers.length}
                  pageable={true}
                  onPageChange={pageChange}

            >

                <Column field="groupLiverId" title="Group Liver Id" cell={groupLiverIdCell} width={200}/>
                <Column field="diTypeDescription" title="COI Type" width={300}/>
                <Column field="groupLiverDescription" title="Group Liver Description" width={300}/>

            </Grid>

        </Fragment>
    )
})
